import moment from 'moment';
import React, { useEffect } from 'react';
import DatePicker from 'react-datepicker';
import Header from '../Header/AppHeader';

var NonConflictData = [
    {
        startTime: "0:00",
        endTime: "1:30",
        color: "#f6be23",
        title: "#Randhir",
    },
    {
        startTime: "4:30",
        endTime: "7:30",
        color: "#f6501e",
        title: "#Gayathri",
    },
    {
        startTime: "12:00",
        endTime: "13:30",
        color: "#029be5",
        title: "#TeamDevkode",
    },
    {
        startTime: "9:00",
        endTime: "10:00",
        color: "#029be5",
        title: "#TeamDevkode",
    },
    {
        startTime: "16:00",
        endTime: "19:00",
        color: "#029be5",
        title: "#TeamDevkode",
    },
    {
        startTime: "20:30",
        endTime: "21:00",
        color: "#029be5",
        title: "#TeamDevkode",
    },
]

var ConflictData = [
    {
        startTime: "0:00",
        endTime: "1:00",
        color: "#f6be23",
        title: "Meeting",
    },
    {
        startTime: "0:00",
        endTime: "1:00",
        color: "#f6be23",
        title: "Meeting",
    },
    {
        startTime: "3:30",
        endTime: "7:30",
        color: "#f6501e",
        title: "Meeting",
    },
    {
        startTime: "4:30",
        endTime: "8:30",
        color: "#f6501e",
        title: "Meeting",
    },
    {
        startTime: "6:30",
        endTime: "9:00",
        color: "#f6501e",
        title: "Demo",
    },
    {
        startTime: "11:00",
        endTime: "13:30",
        color: "#029be5",
        title: "Meeting",
    },
    {
        startTime: "12:00",
        endTime: "13:30",
        color: "#029be5",
        title: "Meeting",
    },
    {
        startTime: "9:30",
        endTime: "10:30",
        color: "#029be5",
        title: "Meeting",
    },
    {
        startTime: "16:00",
        endTime: "17:00",
        color: "#029be5",
        title: "Meeting",
    },
    {
        startTime: "15:00",
        endTime: "17:00",
        color: "#029be5",
        title: "Meeting",
    },
    {
        startTime: "18:00",
        endTime: "19:00",
        color: "#f6501e",
        title: "Meeting",
    },
    {
        startTime: "20:30",
        endTime: "22:30",
        color: "#029be5",
        title: "Meeting",
    },
    {
        startTime: "20:30",
        endTime: "22:30",
        color: "#029be5",
        title: "Meeting",
    }
];

const Calender = () => {

    useEffect(() => {
        CalendarStart();
    }, [])

    function CalendarStart() {
        CalendarInit();
        CreateBlock(ConflictData);
    }

    function CalendarInit() {
        var calendar = document.getElementById("calendar");
        var div = document.createElement("div");
        div.classList.add("time")
        for (let i = 0; i < 24; i++) {
            var Innerdiv = div.cloneNode();

            var HoursTimeSlot = i > 12 ? i - 12 : i;
            Innerdiv.innerHTML = `${HoursTimeSlot === 0 ? 12 : HoursTimeSlot}:00 ${i < 12 ? "AM" : "PM"}`;

            calendar.appendChild(Innerdiv);
        }
    }

    function CreateBlock(CalenderData) {
        var formatData = SortData(formatCalenderData(CalenderData));

        var calendar = document.getElementById("calendar");
        var div = document.createElement("div");
        div.classList.add("event");
        if (CalenderData.length === 0) {
            return;
        }

        var SameFirstOne = false;
        var counter = 0;
        for (let schedule of formatData) {
            var divInner = document.createElement("div");
            divInner.classList.add("event");
            divInner.style.backgroundColor = schedule.color;

            let currentStartTime = ConvertToMinutes(schedule.StartHour, schedule.StartMin);
            let currentEndTime = ConvertToMinutes(schedule.EndHour, schedule.EndMin);

            divInner.style.top = `${currentStartTime + 20}px`;

            var conflictingEvents = formatData.filter(data => (ConvertToMinutes(data.StartHour, data.StartMin)
                <= currentStartTime && ConvertToMinutes(data.EndHour, data.EndMin) >= currentStartTime));

            var SameStartTime = formatData.filter(data => (ConvertToMinutes(data.StartHour, data.StartMin)
                === currentStartTime));

            counter = SameStartTime.length > 1 ? ++counter : 0;
            SameFirstOne = SameFirstOne && SameStartTime.length > 1 ? false : SameStartTime.length > 1;
            divInner.style.width = conflictingEvents.length > 0 && counter > 0 ? "100%" : `${100 / conflictingEvents.length}%`;
            divInner.style.left = counter === 0 ? `${100 - (100 / conflictingEvents.length) + 10}%` :
                `${100 - (100 / counter) + 10}%`;
            divInner.style.border = "2px solid white";
            divInner.style.height = `${(currentEndTime - currentStartTime) + 5}px`;

            divInner.innerHTML = schedule.title;
            var Innerdiv = document.createElement("div");
            Innerdiv.style.position = "relative";
            Innerdiv.style.top = "-5px";
            Innerdiv.innerHTML = `${schedule.StartHour > 12 ? schedule.StartHour - 12 : (schedule.StartHour === 0 ? 12 : schedule.StartHour)}${schedule.StartMin > 0 ?
                `:${schedule.StartMin}` : ""} ${(schedule.StartHour > 12 ? "PM" : "AM")} -
                 ${schedule.EndHour > 12 ? schedule.EndHour - 12 : schedule.EndHour}${schedule.EndMin > 0 ? `:${schedule.EndMin}` : ""}
                ${(schedule.EndHour > 12 ? "PM" : "AM")}`;
            divInner.appendChild(Innerdiv);
            calendar.appendChild(divInner);
        }
    }

    function ConvertToMinutes(hour, minute) {
        return (hour * 60) + minute;
    }

    function SortData(array) {
        return array.sort(function (a, b) {
            if (a.totalMinutes < b.totalMinutes) return -1;
            if (a.totalMinutes > b.totalMinutes) return 1;

            return 0;
        });
    }

    function formatCalenderData(data) {
        return data.map(({ startTime, endTime, color, title }) => {
            let [StartHour, StartMin] = startTime.split(":");
            let [EndHour, EndMin] = endTime.split(":");
            let totalMinutes = ConvertToMinutes(parseInt(StartHour), parseInt(StartMin));
            StartHour = parseInt(StartHour);
            StartMin = parseInt(StartMin);
            EndHour = parseInt(EndHour);
            EndMin = parseInt(EndMin);

            return {
                totalMinutes,
                StartHour,
                StartMin,
                EndHour,
                EndMin,
                startTime,
                endTime,
                color,
                title
            }
        });
    }


    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme" style={{ marginBottom: "0.8rem", height: "82vh" }}>
                <div className="row">
                    <div className="col-md-12 col-12 align-center">
                        <h5 style={{ fontWeight: "500", padding: "5px" }}>Manage Calender Events</h5>
                    </div>
                    <div className="col-md-6 col-12">
                        <div id="calendar"></div>
                    </div>
                    <div className="offset-md-1 col-md-4 col-12">
                        <div className="row" style={{ paddingTop: "10px", border: "1px solid #ccc", borderRadius: "10px" }}>
                            <div className="col-md-12 align-center">
                                <h5>Add Calender Event</h5>
                            </div>
                            <div className="col-md-12">
                                <div className="text-field">
                                    <input type="text" placeholder="" name="BillingAddress"></input>
                                    <span>Event Info<span className="mandatoryStar">*</span></span>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <DatePicker className="TextInputStyle datepicker"
                                    showWeekNumbers
                                    // selected={customerData.PreferredDeliveryDate}
                                    // onChange={onDeliveryDateChange}
                                    name="PreferredDeliveryDate"
                                    placeholderText="Event Date *"
                                    dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                            </div>
                            <div className="col-md-6 col-12">
                                <DatePicker
                                    //selected={customerData.PreferredDeliveryDate}
                                    //onChange={onDeliveryDateChange}
                                    // name="PreferredDeliveryDate"
                                    showTimeSelect
                                    timeIntervals={15}
                                    showTimeSelectOnly
                                    placeholderText="From *"
                                    dateFormat="h:mm aa"></DatePicker>
                            </div>
                            <div className="col-md-5 col-12">
                                <DatePicker
                                    //selected={customerData.PreferredDeliveryDate}
                                    //onChange={onDeliveryDateChange}
                                    // name="PreferredDeliveryDate"
                                    showTimeSelect
                                    timeIntervals={15}
                                    showTimeSelectOnly
                                    placeholderText="To *"
                                    dateFormat="h:mm aa"></DatePicker>
                            </div>
                            <div className="col-md-12">
                                <div className="text-field">
                                    <input type="text" placeholder="" name="BillingAddress"></input>
                                    <span>Event Type<span className="mandatoryStar">*</span></span>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="text-field">
                                    <input type="text" placeholder="" name="BillingAddress"></input>
                                    <span>Participants<span className="mandatoryStar">*</span></span>
                                </div>
                            </div>
                            <div style={{ padding: "5px", borderTop: "1px solid #ccc" }} className="col-md-12 col-12 buttonresponsive align-right">
                                <button className={`btn btn-Save`}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Calender;